module.exports = __webpack_public_path__ + "static/media/thumbnail.b7b4103c.jpg";